import Vue from 'vue';
import Router from 'vue-router';
import DefaultContainer from '@/containers/DefaultContainer.vue';
import ProjectContainer from '@/containers/ProjectContainer.vue';
import EmbedContainer from '@/containers/EmbedContainer.vue';

import Login from './views/Login.vue';
import Register from './views/Register.vue';
import Dashboard from './views/Dashboard.vue';
import TimelineRoot from './views/TimelineRoot.vue';
import TimelineListView from './views/timelinelist/Timelines.vue';
import MapView from './views/mapview/MapContainer.vue';
import TimelineEditor from './views/TimelineEditor.vue';
import ResetPassword from './views/ResetPassword.vue';
import ResetPasswordResult from './views/ResetPasswordResult.vue';
import VerificationResult from './views/VerificationResult.vue';
import ProfileView from './views/Profile.vue';
import Reconnect from './views/Reconnect.vue';
import { IsEmbedded } from './constants/environment';
import PricingInfo from './views/landingpage/PricingInfo.vue';

Vue.use(Router);

export default new Router({
    mode: IsEmbedded ? 'hash' : 'history',
    routes: [/*
		{
			path: '/paymenttest',
			name: "Payment Test",
			component: PaymentTest
		},*/
        {
            path: '/',
            name: 'root',
            redirect: '/app',
            component: {
                render (c) 
                {
                    return c('router-view'); 
                }
            },
            children: [
                {
                    path: 'login',
                    name: 'Login',
                    component: Login,
                    meta: {
                        isLogin: true
                    }
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register,
                    meta: {
                        isLogin: true
                    }
                },
                {
                    path: 'forgotpassword',
                    name: 'Forgot Password',
                    component: ResetPassword,
                    meta: {
                        isLogin: true
                    }
                },
                {
                    path: 'resetpassword',
                    name: 'Reset Password',
                    component: ResetPasswordResult,
                    meta: {
                        isLogin: true
                    }
                },
                {
                    path: 'verifyemail',
                    name: 'Email Verification',
                    component: VerificationResult,
                    meta: {
                        canBeLogin: true
                    }
                },
                {
                    path: 'pricing',
                    name: 'Pricing Info',
                    component: PricingInfo,
                    meta: {
                        canBeLogin: true,
                    },
                },
                {
                    path: 'app',
                    name: 'AppRoot',
                    redirect: "/app/dashboard",
                    component: DefaultContainer,
                    children: [
                        {
                            path: "dashboard",
                            name: "Dashboard",
                            component: Dashboard
                        },
                        {
                            path: "connect/:id/",
                            name: "Connect",
                            component: Reconnect
                        },
                        {
                            path: "reconnect/:id/:delay",
                            name: "Reconnect",
                            component: Reconnect
                        },
                        {
                            path: "profile",
                            name: "User Profile",
                            component: ProfileView
                        },
                        {
                            path: "project",
                            name: "Project",
                            component: ProjectContainer,
                            meta: {
                                isRoot: true
                            },
                            children: [
                                {
                                    path: "timelines",
                                    name: "Timeline List",
                                    component: TimelineRoot,
                                    redirect: "/app/project/timelines/list",
                                    meta: {
                                        isTimelineList: true
                                    },
                                    children: [
                                        {
                                            path: "map",
                                            name: "Map View",
                                            component: MapView
                                        },
                                        {
                                            path: "list",
                                            name: "List View",
                                            component: TimelineListView
                                        }
                                    ],
                                },
                                {
                                    path: "timeline/:id",
                                    name: "Timeline",
                                    component: TimelineEditor
                                },
                            ]
                        },
                        {
                            path: "e",
                            name: "Invalid Embed Link",
                            component: EmbedContainer,
                        },
                        {
                            path: "e/:encoded",
                            name: "Embedded Project",
                            component: EmbedContainer,
                            meta: {
                                isRoot: true,
                                allowAnonymous: true
                            },
                            children: [
                                {
                                    path: "timelines",
                                    name: "Embedded Timeline List",
                                    component: TimelineRoot,
                                    redirect: "list",
                                    meta: {
                                        isTimelineList: true,
                                        allowAnonymous: true
                                    },
                                    children: [
                                        {
                                            path: "map",
                                            name: "Embedded Map View",
                                            component: MapView,
                                            meta: {
                                                allowAnonymous: true
                                            }
                                        },
                                        {
                                            path: "list",
                                            name: "Embedded List View",
                                            component: TimelineListView,
                                            meta: {
                                                allowAnonymous: true
                                            }
                                        }
                                    ],
                                },
                                {
                                    path: "timeline/:id",
                                    name: "Embedded Timeline",
                                    component: TimelineEditor,
                                    meta: {
                                        allowAnonymous: true
                                    }
                                },
                            ]
                        },
                    ]
                },
            ]
        },

        // Redirect to main if the page isn't found.  Maybe this should be a 404 page?
        {
            path: "*", redirect: "/"
        }
    ]
});
